jQuery(document).ready(function ($) {
  $(".heading_with_accordian_section").each(function () {
    const $section = $(this);

    const $firstHeading = $section.find(".accordian_heading").first();
    const $firstItem = $firstHeading.parent();

    $firstHeading.next().slideDown();
    $firstItem.addClass("active");

    const accordianIndex = $firstItem.data("accordian");
    $section
      .find(`.accordian_images_section .accrodian_image_${accordianIndex}`)
      .addClass("active");

    $section.find(".accordian_heading").on("click", function () {
      const $parent = $(this).parent();
      const accordianIndex = $parent.data("accordian");

      if ($(this).next().is(":hidden")) {
        $section.find(".accordian_content_section_item").removeClass("active");
        $section.find(".accordian_content_wrapper").slideUp();
        $section
          .find(".accordian_images_section .accordian_image")
          .removeClass("active");

        $(this).next().slideDown();
        $parent.addClass("active");
        $section
          .find(`.accordian_images_section .accrodian_image_${accordianIndex}`)
          .addClass("active");
      } else {
        $(this).next().slideUp();
        $parent.removeClass("active");
        $section
          .find(".accordian_images_section .accordian_image")
          .removeClass("active");
      }

      if (jQuery(window).width() < 768) {
        var acc_heading = this;
        setTimeout(() => {
          jQuery("body, html").animate(
            {
              scrollTop: jQuery(acc_heading).offset().top - 120,
            },
            500
          );
        }, 500);
      }
    });
  });
});
